import { createSlice } from '@reduxjs/toolkit';

const vatandasSurveySlice = createSlice({
    name: 'survey',
    initialState: {
        surveys: [],
        error: null,
        loading: false,            // [EKLENDİ] Anketler yüklenirken
        sending: false,            // [EKLENDİ] Yanıt gönderilirken
        sendSuccess: false,        // [EKLENDİ] Yanıt gönderildi
        sendError: null,           // [EKLENDİ] Yanıt gönderme hatası
    },
    reducers: {
        setSurveys(state, action) {
            state.surveys = action.payload;
            state.error = null;
            state.loading = false;
        },
        setError(state, action) {
            state.error = action.payload;
            state.loading = false;
        },
        setLoading(state, action) {         // [EKLENDİ]
            state.loading = action.payload;
        },
        setSending(state, action) {         // [EKLENDİ]
            state.sending = action.payload;
        },
        setSendSuccess(state, action) {     // [EKLENDİ]
            state.sendSuccess = action.payload;
        },
        setSendError(state, action) {       // [EKLENDİ]
            state.sendError = action.payload;
        },
        resetSurveyState(state) {           // [EKLENDİ] Her formdan sonra sıfırla
            state.sending = false;
            state.sendSuccess = false;
            state.sendError = null;
        }
    },
});

export const {
    setSurveys,
    setError,
    setLoading,
    setSending,
    setSendSuccess,
    setSendError,
    resetSurveyState,
} = vatandasSurveySlice.actions;

export default vatandasSurveySlice.reducer;
